import { window } from 'browser-monads';
import { APP_LOAD, REDIRECT } from '../types';
import { setToken } from 'libs';

export const onAppLoad = () => {
  const accessData = JSON.parse(
    window.localStorage.getItem('collectionsAccessData')
  );
  const user = JSON.parse(window.localStorage.getItem('collectionsUser'));

  if (accessData?.token) {
    setToken(accessData.token);
  }
  return {
    type: APP_LOAD,
    isAuthenticated: !!accessData?.token,
    user,
  };
};

export const onRedirect = () => ({
  type: REDIRECT,
});
